export function LDecimalPlaces(aNumber, places) {
  var result = aNumber.toFixed(places).toString();
  return result;
}
